import { FC} from "react";
import { NavLink } from "react-router-dom"
import { HeaderNav } from "@sainsburys-tech/luna-header";
import routes from '../../../../routes';
import './index.scss'
import { verifyUserAccess } from "../../../../Utils/auth-utils";

const Navbar: FC = () => {
    const filterLinks = routes.filter(x=>!x.isChild && x.submenu===undefined)

    // eslint-disable-next-line array-callback-return
        filterLinks?.map(x=>{
            let permission = verifyUserAccess(x.name)
            x.hasLinkAccess=permission.hasScreenAccess;
        })
    const links = filterLinks?.filter(d=>d.hasLinkAccess).map((data) => {
        return <div>
            {data.submenu === undefined? 
            <NavLink activeClassName="active-link" key={data.path} to={data.path} className="header-item__link remove-link">
                {data.name}
            </NavLink> : 
            <div>
                {/* <ListGroupDropdown id="shop">
                    Shop with us
                    <ListGroup>
                        <ListGroupItem element="a" href="#groceries">
                            Groceries
                        </ListGroupItem>
                        <ListGroupItem element="a" href="#tu">
                            Tu
                        </ListGroupItem>
                        
                    </ListGroup>
                </ListGroupDropdown> */}
            </div>
            }
        </div>
    })
    return (
        <HeaderNav openDropdownOnHover drawer label="Main">
            {
                links
            }
        </HeaderNav>
    )
}

export default Navbar;